import type { FC } from 'react'
import type { SxProps, Theme } from '@mui/material'
import { Box, useTheme } from '@mui/material'
import type { ClaudeSession } from '@/features/events/conversation/state/types'
import type {
  FormattedAgentActivity,
  FormattedUserActivity,
} from '@/features/events/activity/utils/types'
import { resolveSessionBorderColor } from '@/features/events/conversation/tree/renderers/SessionNodeRenderer'
import { DemoSessionOrchestrator } from '@/features/home/demo'

// ---------------------------------------------------------------------------
// Public API
// ---------------------------------------------------------------------------

interface DemoSessionCardProps {
  readonly session: ClaudeSession
  readonly userActivity?: FormattedUserActivity | null
  readonly currentActivity?: FormattedAgentActivity | FormattedUserActivity | null
  readonly userReplyText?: string | null
}

export const DemoSessionCard: FC<DemoSessionCardProps> = ({
  session,
  userActivity,
  currentActivity,
  userReplyText,
}) => {
  const theme = useTheme()
  const borderColor = resolveSessionBorderColor(session, theme)

  return (
    <Box sx={cardSx(borderColor)}>
      <DemoSessionOrchestrator
        session={session}
        {...(userActivity === undefined ? {} : { userActivity })}
        {...(currentActivity === undefined ? {} : { currentActivity })}
        {...(userReplyText === undefined ? {} : { userReplyText })}
      />
    </Box>
  )
}

// ---------------------------------------------------------------------------
// Styles
// ---------------------------------------------------------------------------

const cardSx =
  (borderColor: string): SxProps<Theme> =>
  (theme) => ({
    border: `2px solid ${borderColor}`,
    borderRadius: 1,
    backgroundColor:
      theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.04)' : 'rgba(62, 39, 35, 0.03)',
    padding: 1.5,
    '& *': { cursor: 'default' },
  })
